// eslint-disable-next-line import/prefer-default-export
export const SET_ACTIVE_TAB = 'actionId/SET_ACTIVE_TAB'
